var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"doughnut-chart"},[_c('b-card-title',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.chartName)+" ")]),_c('vue-apex-charts',{attrs:{"type":"donut","height":"350","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }